import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { API_URL } from '../constants';
import { AuthContext } from '../context/AuthContext';
import { TechnicalSpec } from '../types/technical-sheet';
import TechnicalSpecSheet from '../components/TechnicalSpecSheet';

const TechnicalSheetEdit: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { hasPermission, isAdmin } = useContext(AuthContext);
  
  // Form state'i
  const [technicalSpec, setTechnicalSpec] = useState<TechnicalSpec>({
    dynamicSizeTable: {
      columns: [],
      rows: [],
      data: {}
    },
    fabricSpecs: [],
    stitchDetails: [],
    printingDetails: [],
    careInstructions: [],
    qualityStandards: [],
    notes: ''
  });

  useEffect(() => {
    if (!productId) return;
    fetchProductData();
  }, [productId]);

  const fetchProductData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/products/${productId}`);
      if (!response.ok) throw new Error('Ürün bulunamadı');
      
      const product = await response.json();
      if (product.technicalSpec) {
        // Eğer dynamicSizeTable yoksa varsayılan yapıyı oluştur
        const techSpec = {
          ...product.technicalSpec,
          dynamicSizeTable: product.technicalSpec.dynamicSizeTable || {
            columns: [],
            rows: [],
            data: {}
          }
        };
        setTechnicalSpec(techSpec);
      }
      
      setLoading(false);
    } catch (err) {
      setError('Veri yüklenirken hata oluştu');
      setLoading(false);
    }
  };

  // Form gönderme
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setSaving(true);
      console.log('Gönderilen veri:', technicalSpec); // Debug için

      const response = await fetch(`${API_URL}/products/${productId}/technical-spec`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(technicalSpec)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Güncelleme başarısız');
      }
      
      const updatedProduct = await response.json();
      console.log('Güncelleme başarılı:', updatedProduct); // Debug için
      
      navigate(`/technical-sheet/${productId}`);
    } catch (err) {
      console.error('Güncelleme hatası:', err);
      setError(err instanceof Error ? err.message : 'Güncelleme sırasında hata oluştu');
      setSaving(false);
    }
  };

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div>Hata: {error}</div>;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="bg-gray-50 p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-800">Teknik Föy Düzenleme</h1>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <TechnicalSpecSheet 
            techSpec={technicalSpec}
            setTechSpec={setTechnicalSpec}
          />

          {/* Form Kontrolleri */}
          <div className="flex justify-end space-x-4 pt-6 border-t">
            <Link
              to={`/technical-sheet/${productId}`}
              className="px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-50"
            >
              İptal
            </Link>
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            >
              {saving ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TechnicalSheetEdit;
